"use client";

import React, { useEffect, useRef, useState } from 'react';
import { MenuNav } from '@/shared/components/menu/nav-menu';
import { MenuCats } from '@/shared/components/menu/menu-cats';
import { FoodCategory, FoodItem } from '@/root/types';
import { useStateValue } from '@/providers/state-provider';

type MenuPageClientProps = {
    categories: FoodCategory[];
    items: FoodItem[];
  };
const MenuPageClient: React.FC<MenuPageClientProps> = ({ categories, items }) => {
  const { dispatch } = useStateValue();
  const hasDispatched = useRef(false);

  useEffect(() => {
      dispatch({ type: 'SET_FOOD_CATEGORIES', foodCategories: categories });
      dispatch({ type: 'SET_FOOD_ITEMS', foodItems: items });
  }, [categories, items]);
  
  const sectionsRef = useRef<(HTMLElement | null)[]>([]);
  const menuRef = useRef<HTMLElement | null>(null);
  const [activeSection, setActiveSection] = useState<number | null>(null);
  const isScrolling = useRef(false);
  const scrollTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024); // Or use any breakpoint logic you need
    };
    window.addEventListener('resize', handleResize);
    handleResize(); // Set initial state
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (isScrolling.current) return;

      // Get the header and sidebar heights
      const header = document.querySelector('.header');
      const headerOffset = header instanceof HTMLElement ? header.offsetHeight : 0;

      // Adjust the offset for sidebar visibility
      const sidebar = document.querySelector('.sidebar'); // Replace with your sidebar class
      const sidebarOffset = sidebar instanceof HTMLElement ? sidebar.offsetHeight : 0;

      // Calculate the total offset (header + sidebar if mobile)
      const totalOffset = isMobile ? headerOffset + sidebarOffset : headerOffset;

      const scrollPosition = window.scrollY + window.innerHeight / 2 - totalOffset;

      sectionsRef.current.forEach((section, index) => {
        if (section) {
          const { offsetTop, offsetHeight } = section;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(index);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isMobile]);
  

  const handleMenuClick = (index: number) => {
    const section = sectionsRef.current[index];
    
    if (section) {
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }

      isScrolling.current = true;
      const header = document.querySelector('.header-page');
      var headerOffset = header instanceof HTMLElement ? header.offsetHeight : 80;
      if(isMobile){
        const menuNavElmnt = document.querySelector('nav.menuNav');
        const menuNavElmntOffset = menuNavElmnt instanceof HTMLElement ? menuNavElmnt.offsetHeight : 0;
        //headerOffset = headerOffset + menuNavElmntOffset;
      }

      const sectionPosition = section.offsetTop;
      const offsetPosition = sectionPosition - headerOffset - 40;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
      setActiveSection(index);

      scrollTimeout.current = setTimeout(() => {
        isScrolling.current = false;
      }, 1000);
    }
  };

  useEffect(() => {
    if (activeSection !== null && menuRef.current) {
      const menuItems = menuRef.current.querySelectorAll('.menuNavButton');

      const activeMenuItem = menuItems[activeSection];
      if (activeMenuItem) {
        const { offsetWidth, offsetLeft } = activeMenuItem as HTMLElement;

        menuRef.current.scrollTo({
          left: offsetLeft - menuRef.current.offsetWidth / 2 + offsetWidth / 2,
          behavior: 'smooth',
        });
      }
    }
  }, [activeSection]);

  

  return (
    <div className='menuArea pb-10'>
      <MenuNav
        categories={categories}
        activeSectionIndex={activeSection}
        onMenuClick={handleMenuClick}
        menuRef={menuRef}
      />
      <MenuCats
        categories={categories}
        items={items}
        sectionsRef={sectionsRef}
      />
    </div>
  );
}

export default MenuPageClient;